export default __webpack_public_path__ + "static/media/waiting.aa48c8b8.png";